<template>
  <div
    class="wrapper"
    :class="[
      { 'nav-open': $sidebar.showSidebar },
      { rtl: $route.meta.rtlActive }
    ]"
  >
    <side-bar
      :active-color="sidebarBackground"
      :background-image="sidebarBackgroundImage"
      :data-background-color="sidebarBackgroundColor"
      style="font-weight: bold;"
    >
      <LogoMenu></LogoMenu>
      <div v-show="usertype !== USER_TYPE.AIRPORT">
        <DashboardMenu></DashboardMenu>
      </div>
      <MapMenu></MapMenu>

      <div v-show="usertype !== USER_TYPE.AIRPORT">
        <MissionMenu></MissionMenu>
        <ResourceMenu></ResourceMenu>
      </div>

      <div v-show="usertype === USER_TYPE.AIRPORT">
        <AirportMenu></AirportMenu>
        <NoticeMenu></NoticeMenu>
      </div>

      <div
        v-show="[USER_TYPE.PILOT, USER_TYPE.AIRPORT].indexOf(usertype) === -1"
      >
        <FlightReviewMenu></FlightReviewMenu>
      </div>

      <div v-show="usertype !== USER_TYPE.AIRPORT">
        <SettingMenu></SettingMenu>
      </div>
      <div v-show="usertype === USER_TYPE.ADMIN">
        <AdminsMenu></AdminsMenu>
      </div>

      <div v-show="usertype !== USER_TYPE.AIRPORT">
        <ContactUsMenu></ContactUsMenu>
      </div>

      <div v-show="usertype === USER_TYPE.FREE || usertype === USER_TYPE.PRO">
        <UpgradeMenu></UpgradeMenu>
      </div>
    </side-bar>

    <div class="main-panel">
      <top-navbar></top-navbar>
      <div @click="toggleSidebar">
        <zoom-center-transition :duration="200" mode="out-in">
          <router-view></router-view>
        </zoom-center-transition>
      </div>
    </div>
    <content-footer v-if="!$route.meta.hideFooter"></content-footer>
    <Notifications />
  </div>
</template>
<script>
/* eslint-disable no-new */
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";

function hasElement(className) {
  return document.getElementsByClassName(className).length > 0;
}

function initScrollbar(className) {
  if (hasElement(className)) {
    new PerfectScrollbar(`.${className}`);
  } else {
    // try to init it later in case this component is loaded async
    setTimeout(() => {
      initScrollbar(className);
    }, 100);
  }
}

import ContentFooter from "./ContentFooter.vue";
import TopNavbar from "./TopNavbar.vue";
import LogoMenu from "./Extra/LogoMenu.vue";
import DashboardMenu from "./Extra/DashboardMenu.vue";
import MapMenu from "./Extra/MapMenu.vue";
import MissionMenu from "./Extra/MissionMenu.vue";
import AirportMenu from "./Extra/AirportMenu.vue";
import NoticeMenu from "./Extra/NoticeMenu.vue";
import SettingMenu from "./Extra/SettingMenu.vue";
import FlightReviewMenu from "./Extra/FlightReviewMenu.vue";
import ResourceMenu from "./Extra/ResourceMenu.vue";
import AdminsMenu from "./Extra/AdminMenu.vue";
import UpgradeMenu from "./Extra/UpgradeMenu.vue";
import ContactUsMenu from "./Extra/ContactUsMenu.vue";
import { ZoomCenterTransition } from "vue2-transitions";
import { mapFields } from "vuex-map-fields";
import { USER_TYPE, PILOT_NETWORK } from "@/const.js";

export default {
  components: {
    ContentFooter,
    TopNavbar,
    LogoMenu,
    DashboardMenu,
    MapMenu,
    MissionMenu,
    AirportMenu,
    NoticeMenu,
    SettingMenu,
    FlightReviewMenu,
    ResourceMenu,
    AdminsMenu,
    UpgradeMenu,
    ContactUsMenu,
    ZoomCenterTransition
  },
  data() {
    return {
      USER_TYPE: USER_TYPE,
      PILOT_NETWORK: PILOT_NETWORK,
      sidebarBackgroundColor: "black",
      sidebarBackground: "green",
      sidebarBackgroundImage: "",
      sidebarMini: true,
      sidebarImg: true,
      isClosed: true
    };
  },
  computed: {
    ...mapFields("auth", ["usertype", "plan_type", "pilot_network"])
  },
  methods: {
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },
    minimizeSidebar() {
      if (this.$sidebar) {
        this.$sidebar.toggleMinimize();
      }
    }
  },
  mounted() {
    let docClasses = document.body.classList;
    let isWindows = navigator.platform.startsWith("Win");
    if (isWindows) {
      // if we are on windows OS we activate the perfectScrollbar function
      initScrollbar("sidebar");
      initScrollbar("sidebar-wrapper");
      initScrollbar("main-panel");

      docClasses.add("perfect-scrollbar-on");
    } else {
      docClasses.add("perfect-scrollbar-off");
    }
  },
  watch: {
    sidebarMini() {
      this.minimizeSidebar();
    }
  }
};
</script>
<style lang="scss">
/* The side navigation menu */
.sidebarb {
  margin: 0;
  padding: 0;
  width: 200px;
  background-color: lightgrey;
  position: fixed;
  height: 100%;
  overflow: auto;
}

/* Sidebar links */
.sidebarb a {
  display: block;
  color: black;
  padding: 16px;
  text-decoration: none;
}

/* Active/current link */
.sidebarb a.active {
  background-color: #4caf50;
  color: white;
}

/* Links on mouse-over */
.sidebarb a:hover:not(.active) {
  background-color: #555;
  color: white;
}

/* Page content. The value of the margin-left property should match the value of the sidebar's width property */
div.content {
  margin-left: 200px;
  padding: 1px 16px;
  height: 1000px;
}

@media screen and (min-width: 980px) {
}

/* On screens that are less than 700px wide, make the sidebar into a topbar */
@media screen and (min-width: 780px) {
  .sidebarb {
    width: 100%;
    height: auto;
    position: relative;
  }
  .sidebarb a {
    float: left;
  }
  div.content {
    margin-left: 0;
  }
  .wrappers {
    position: relative;
    top: 0;
    height: 90vh;
  }
}

@media screen and (max-width: 770px) {
  .sidebarb a {
    text-align: center;
    float: none;
  }
  .wrappers {
    position: relative;
    top: 0;
    height: 90vh;
  }
  .footer ul li a {
    color: inherit !important;
    padding: 15px;
    font-weight: 500;
    font-size: 8px;
    text-transform: uppercase;
    border-radius: 3px;
    text-decoration: none;
    position: relative;
    display: block;
  }
}
@media screen and (max-width: 400px) {
  .sidebarb a {
    text-align: center;
    float: none;
  }
  .wrappers {
    position: fixed;
    top: 0;
    height: 90vh;
  }
}
/* On screens that are less than 400px, display the bar vertically, instead of horizontally */
@media screen and (max-height: 500px) {
  .sidebarb a {
    text-align: center;
    float: none;
  }
  .wrappers {
    position: fixed;
    top: 0;
    height: 85vh;
  }
  footer nav,
  footer .copyright {
    display: float;
  }
}
$scaleSize: 0.95;
@keyframes zoomIn95 {
  from {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
  to {
    opacity: 1;
  }
}
.main-panel .zoomIn {
  animation-name: zoomIn95;
}
@keyframes zoomOut95 {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
}
.main-panel .zoomOut {
  animation-name: zoomOut95;
}
.main-panel {
  position: relative;
  float: right;
  background-color: #fbfbfb;
}
</style>
